import { render } from "./Comment.vue?vue&type=template&id=bfe37f12&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=bfe37f12&lang=scss&scoped=true"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe37f12"]])

export default __exports__